<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1">
      
      <!-- Loading Payment Option -->
      <div *ngIf="paymentOption_load" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="text-muted mt-3">Cargando información de la opción de pago...</p>
      </div>

      <!-- Payment Option Header -->
      <div *ngIf="!paymentOption_load && paymentOption" class="row mb-2">
        <div class="col-12">
          
          <!-- Back Button -->
          <div class="mb-4">
            <button 
              type="button" 
              class="btn btn-outline-primary"
              (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>
              Volver a Métodos de Pago
            </button>
          </div>

          <!-- Payment Option Info Card -->
          <div class="card payment-option-card">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="d-flex align-items-center">
                    <div class="payment-option-icon me-3">
                      {{ getPaymentOptionIcon() }}
                    </div>
                    <div>
                      <h4 class="card-title mb-1">{{ paymentOption.name }}</h4>
                      <p class="text-muted mb-2">{{ paymentOption.description || 'Gestión de cuentas asociadas' }}</p>
                      <div class="d-flex gap-2">
                        <span class="badge badge-primary">{{ paymentOption.code }}</span>
                        <span *ngIf="isPaymentOptionActive()" class="badge badge-success">
                          <i class="bi bi-check-circle me-1"></i>Activo
                        </span>
                        <span *ngIf="!isPaymentOptionActive()" class="badge badge-secondary">
                          <i class="bi bi-x-circle me-1"></i>Inactivo
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 text-md-end">
                  <div class="payment-option-stats">
                    <div class="stat-item">
                      <span class="stat-number">{{ getTotalAccountsCountUnfiltered() }}</span>
                      <span class="stat-label">Cuentas Totales</span>
                    </div>
                    <div class="stat-item">
                      <span class="stat-number text-primary">{{ getActiveAccountsCountUnfiltered() }}</span>
                      <span class="stat-label">Activas</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Methods Administration Section (Solo para "Otros métodos de pagos") -->
      <div *ngIf="!paymentOption_load && isOtrosMetodosDePagos()" class="row mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header clickable-header" 
                 (click)="paymentMethodsCollapsed = !paymentMethodsCollapsed"
                 (keyup.enter)="paymentMethodsCollapsed = !paymentMethodsCollapsed"
                 (keyup.space)="paymentMethodsCollapsed = !paymentMethodsCollapsed"
                 tabindex="0"
                 role="button"
                 [attr.aria-expanded]="!paymentMethodsCollapsed"
                 style="cursor: pointer;">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="bi me-2" [class.bi-chevron-right]="paymentMethodsCollapsed" [class.bi-chevron-down]="!paymentMethodsCollapsed"></i>
                  <i class="bi bi-credit-card-2-front me-2"></i>Administración de Métodos de Pago
                </h5>
                <span class="badge badge-info">
                  {{ getActivePaymentMethodsCount() }} de {{ getTotalPaymentMethodsCount() }} activos
                </span>
              </div>
            </div>
            <div class="card-body" *ngIf="!paymentMethodsCollapsed">
              <!-- Loading Payment Methods -->
              <div *ngIf="paymentMethods_load" class="text-center py-3">
                <div class="spinner-border spinner-border-sm text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="text-muted mt-2 mb-0">Cargando métodos de pago...</p>
              </div>

              <!-- Payment Methods List -->
              <div *ngIf="!paymentMethods_load && paymentMethodsListFiltered?.length > 0" class="row g-3">
                <div 
                  *ngFor="let paymentMethod of paymentMethodsListFiltered" 
                  class="col-12 col-md-6 col-lg-4">
                  <div class="card h-100 payment-method-card"
                       [class.active-method]="paymentMethod.showClient"
                       [class.inactive-method]="!paymentMethod.showClient">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h6 class="card-title mb-1">{{ paymentMethod.name }}</h6>
                          <small class="text-muted">{{ paymentMethod.code }}</small>
                        </div>
                        <span 
                          class="badge"
                          [class.badge-success]="paymentMethod.showClient"
                          [class.badge-secondary]="!paymentMethod.showClient">
                          <i class="bi" 
                             [class.bi-eye]="paymentMethod.showClient"
                             [class.bi-eye-slash]="!paymentMethod.showClient"></i>
                          {{ paymentMethod.showClient ? 'Visible' : 'Oculto' }}
                        </span>
                      </div>
                      
                      <p class="card-text small text-muted mb-3" *ngIf="paymentMethod.description">
                        {{ paymentMethod.description }}
                      </p>

                      <div class="d-grid">
                        <button 
                          type="button" 
                          class="btn btn-sm"
                          [class.btn-outline-danger]="paymentMethod.showClient"
                          [class.btn-outline-success]="!paymentMethod.showClient"
                          (click)="changePaymentMethodStatus(paymentMethod._id, !paymentMethod.showClient)">
                          <i class="bi" 
                             [class.bi-eye-slash]="paymentMethod.showClient"
                             [class.bi-eye]="!paymentMethod.showClient"></i>
                          {{ paymentMethod.showClient ? 'OCULTAR' : 'MOSTRAR' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty State -->
              <div *ngIf="!paymentMethods_load && paymentMethodsListFiltered?.length === 0" class="text-center py-4">
                <i class="bi bi-inbox display-4 text-muted"></i>
                <p class="text-muted mt-3 mb-0">No hay métodos de pago asociados a esta opción de pago</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters Section -->
      <div *ngIf="!paymentOption_load && !accountPayment_load" class="row mb-4">
        <div class="col-12">
          <div class="card filters-card">
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="bi bi-funnel me-2"></i>Filtros
                    </h5>
                <div class="d-flex gap-2">
                  <span *ngIf="hasActiveFilters()" class="badge badge-info">
                    {{ getTotalAccountsCount() }} de {{ getTotalAccountsCountUnfiltered() }} cuentas
                  </span>
                  <button 
                    *ngIf="hasActiveFilters()" 
                    type="button" 
                    class="btn btn-outline-secondary btn-sm"
                    (click)="clearFilters()">
                    <i class="bi bi-x-circle me-1"></i>Limpiar Filtros
                  </button>
                </div>
                </div>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <!-- Filter by Bank -->
                <div class="col-md-3">
                  <label class="form-label fw-bold">
                    <i class="bi bi-bank me-2"></i>Banco
                  </label>
                  <select 
                    class="form-select filter-select"
                    [value]="filters.bank"
                    (change)="onFilterChange('bank', $event)">
                    <option value="all">Todos los bancos</option>
                    <option *ngFor="let bank of uniqueBanks" [value]="bank.code">
                      {{ bank.name }}
                    </option>
                  </select>
            </div>

                <!-- Filter by Account Type -->
                <div class="col-md-3">
                  <label class="form-label fw-bold">
                    <i class="bi bi-credit-card me-2"></i>Tipo de Cuenta
                  </label>
                  <select 
                    class="form-select filter-select"
                    [value]="filters.accountType"
                    (change)="onFilterChange('accountType', $event)">
                    <option value="all">Todos los tipos</option>
                    <option *ngFor="let type of uniqueAccountTypes" [value]="type.code">
                      {{ type.name }}
                                        </option>
                                </select>
                </div>

                <!-- Filter by Automatic Verification -->
                <div class="col-md-3">
                  <label class="form-label fw-bold">
                    <i class="bi bi-shield-check me-2"></i>Verificación Automática
                  </label>
                  <select 
                    class="form-select filter-select"
                    [value]="filters.automaticVerification"
                    (change)="onFilterChange('automaticVerification', $event)">
                    <option value="all">Todas las verificaciones</option>
                    <option value="auto">Automáticas</option>
                    <option value="manual">Manuales</option>
                  </select>
                </div>

                <!-- Filter by Client Visibility -->
                <div class="col-md-3">
                  <label class="form-label fw-bold">
                    <i class="bi bi-eye me-2"></i>Visibilidad al Cliente
                  </label>
                  <select 
                    class="form-select filter-select"
                    [value]="filters.clientVisibility"
                    (change)="onFilterChange('clientVisibility', $event)">
                    <option value="all">Todas las visibilidades</option>
                    <option value="visible">Visibles</option>
                    <option value="hidden">Ocultas</option>
                  </select>
                </div>
            </div>

              <!-- Active Filters Summary -->
              <div *ngIf="hasActiveFilters()" class="mt-3 pt-3 border-top">
                <div class="d-flex flex-wrap gap-2">
                  <span class="text-muted me-2">Filtros activos:</span>
                  <span *ngIf="filters.bank !== 'all'" class="badge badge-filter">
                    <i class="bi bi-bank me-1"></i>
                    {{ getBankName(filters.bank) }}
                  </span>
                  <span *ngIf="filters.accountType !== 'all'" class="badge badge-filter">
                    <i class="bi bi-credit-card me-1"></i>
                    {{ getAccountTypeName(filters.accountType) }}
                  </span>
                  <span *ngIf="filters.automaticVerification !== 'all'" class="badge badge-filter">
                    <i class="bi bi-shield-check me-1"></i>
                    {{ filters.automaticVerification === 'auto' ? 'Automática' : 'Manual' }}
                  </span>
                  <span *ngIf="filters.clientVisibility !== 'all'" class="badge badge-filter">
                    <i class="bi bi-eye me-1"></i>
                    {{ filters.clientVisibility === 'visible' ? 'Visible' : 'Oculta' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading Accounts -->
      <div *ngIf="accountPayment_load" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="text-muted mt-3">Cargando cuentas...</p>
                  </div>

      <!-- Accounts List -->
      <div *ngIf="!accountPayment_load && accountPaymentFiltered?.length > 0" class="row">
        <div class="col-12">
          <div class="accounts-grid">
            <div 
              *ngFor="let account of accountPaymentFiltered; let i = index" 
              class="account-card"
              [style.animation-delay]="(i * 0.1) + 's'">
              
              <div class="card h-100"
                   [class.active-account]="account.showClient"
                   [class.inactive-account]="!account.showClient">
                <div class="card-body">
                  <!-- Account Header -->
                  <div class="account-header">
                    <div class="account-info">
                      <h5 class="account-name">
                        <span *ngIf="account.bank?.name" class="bank-name">
                          {{ account.bank.name }}
                          <span *ngIf="account.bank?.tag" class="bank-tag">({{ account.bank.tag }})</span>
                        </span>
                        <span *ngIf="account.bank?.name && account.name" class="separator"> - </span>
                        <span>{{ account.name }}</span>
                      </h5>
                      <!-- Account Badges -->
                      <div class="account-badges">
                        <span class="badge badge-method">
                          <i class="fas fa-credit-card me-1"></i>
                          {{ account.payment_method?.name || 'Método no especificado' }}
                          <!-- Domiciliación Indicator -->
                          <i *ngIf="account.payment_method?.code === 'DOMICILIACION'" 
                             class="fas fa-star ms-1 text-warning" 
                             title="Autocobro - Domiciliación"></i>
                        </span>
                        <span 
                          class="badge"
                          [class.badge-auto]="account.typeConfirm === 'AUTO'"
                          [class.badge-manual]="account.typeConfirm !== 'AUTO'">
                          <i class="fas" 
                             [class.fa-robot]="account.typeConfirm === 'AUTO'"
                             [class.fa-user]="account.typeConfirm !== 'AUTO'"></i>
                          <span *ngIf="account.typeConfirm === 'AUTO'">
                            <i class="fas fa-check me-1"></i>
                            Verificación Automática
                          </span>
                          <span *ngIf="account.typeConfirm !== 'AUTO'">
                            Verificación Manual
                          </span>
                        </span>
                        <span 
                          class="badge"
                          [class.badge-client-visible]="account.showClient"
                          [class.badge-client-hidden]="!account.showClient">
                          <i class="fas" 
                             [class.fa-eye]="account.showClient"
                             [class.fa-eye-slash]="!account.showClient"></i>
                          <span *ngIf="account.showClient">
                            <i class="fas fa-check me-1"></i>
                            Visible al Cliente
                          </span>
                          <span *ngIf="!account.showClient">
                            Oculto al Cliente
                          </span>
                        </span>
                        <!-- Domiciliación Badge (Alternative) -->
                        <span *ngIf="account.payment_method?.code === 'DOMICILIACION'" 
                              class="badge badge-domiciliacion">
                          <i class="fas fa-star me-1"></i>
                          Autocobro
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Warning: Account visible but method hidden -->
                  <div *ngIf="isAccountVisibleButMethodHidden(account)" 
                       class="alert alert-warning warning-message d-flex align-items-start mb-3" 
                       role="alert">
                    <i class="bi bi-exclamation-triangle-fill me-2 flex-shrink-0"></i>
                    <small class="mb-0">
                      <strong>Advertencia:</strong> Este método de pago está visible al cliente, 
                      pero el <strong>Método de Pago principal ({{ account.payment_method?.name }})</strong> 
                      está oculto. El cliente <strong>NO</strong> podrá ver esta cuenta hasta que se active 
                      el método de pago principal.
                    </small>
                  </div>

                  <!-- Account Details -->
                  <div class="account-details">
                    <!-- Priority Display -->
                    <div class="detail-row priority-row">
                      <span class="detail-label">
                        <i class="bi bi-sort-numeric-down me-2"></i>Prioridad:
                      </span>
                      <span class="detail-value priority-value">
                        {{ getAccountPosition(account) }} de {{ getTotalFilteredAccounts() }}
                      </span>
                    </div>
                    
                    <div class="detail-row">
                      <span class="detail-label">
                        <i class="bi bi-tag me-2"></i>Tipo:
                      </span>
                      <span class="detail-value">{{ account.payment_method?.name || 'No especificado' }}</span>
                    </div>
                    
                    <div class="detail-row">
                      <span class="detail-label">
                        <i class="bi bi-currency-dollar me-2"></i>Moneda:
                      </span>
                      <span class="detail-value">{{ account.currency?.name || 'No especificada' }}</span>
                    </div>
                    
                    <div class="detail-row">
                      <span class="detail-label">
                        <i class="bi bi-hash me-2"></i>RIF:
                      </span>
                      <span class="detail-value">{{ account.taxId || 'No especificado' }}</span>
                  </div>

                    <div class="detail-row" *ngIf="account.number">
                      <span class="detail-label">
                        <i class="bi bi-credit-card me-2"></i>Número de Cuenta:
                      </span>
                      <span class="detail-value">{{ account.number }}</span>
                  </div>

                    <div class="detail-row" *ngIf="account.phone">
                      <span class="detail-label">
                        <i class="bi bi-telephone me-2"></i>Teléfono:
                      </span>
                      <span class="detail-value">{{ account.phone }}</span>
                    </div>
                  </div>

                  <!-- Account Actions -->
                  <div class="account-actions">
                    <!-- Priority Controls -->
                    <div class="row g-2 mb-2">
                      <div class="col-12">
                        <div class="d-flex justify-content-center gap-2">
                          <button 
                            type="button" 
                            class="btn btn-outline-primary btn-sm"
                            [disabled]="!canMoveUp(account)"
                            (click)="changePriority(account._id, 'UP')"
                            title="Subir prioridad">
                            <i class="bi bi-arrow-up"></i>
                            <span class="d-none d-sm-inline ms-1">Subir</span>
                          </button>
                          <button 
                            type="button" 
                            class="btn btn-outline-primary btn-sm"
                            [disabled]="!canMoveDown(account)"
                            (click)="changePriority(account._id, 'DOWN')"
                            title="Bajar prioridad">
                            <i class="bi bi-arrow-down"></i>
                            <span class="d-none d-sm-inline ms-1">Bajar</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div class="row g-2">
                      <!-- Verification Toggle -->
                      <div class="col-6">
                        <label class="form-label fw-bold text-muted small">
                          Conciliación Automática:
                        </label>
                        <button 
                          type="button" 
                          class="btn btn-outline-primary w-100"
                          (click)="changeStatusVerification(account._id, account.typeConfirm === 'AUTO' ? 'MANUAL' : 'AUTO')">
                          <i class="bi" [class.bi-person-check]="account.typeConfirm === 'AUTO'" [class.bi-robot]="account.typeConfirm !== 'AUTO'"></i>
                          <span class="d-none d-sm-inline ms-1">
                            {{ account.typeConfirm === 'AUTO' ? 'APAGAR' : 'ENCENDER' }}
                          </span>
                        </button>
                      </div>
                      
                      <!-- Visibility Toggle -->
                      <div class="col-6">
                        <label class="form-label fw-bold text-muted small">
                          Visibilidad al Cliente:
                        </label>
                        <button 
                          type="button" 
                          class="btn btn-outline-primary w-100"
                          (click)="changeStatus(account._id, !account.showClient)">
                          <i class="bi" [class.bi-eye-slash]="account.showClient" [class.bi-eye]="!account.showClient"></i>
                          <span class="d-none d-sm-inline ms-1">
                            {{ account.showClient ? 'OCULTAR' : 'MOSTRAR' }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!accountPayment_load && accountPaymentFiltered?.length === 0" class="text-center py-5">
        <div class="empty-state">
          <i class="bi bi-inbox display-1 text-muted"></i>
          <h3 class="mt-3">
            {{ hasActiveFilters() ? 'No se encontraron cuentas' : 'No hay cuentas disponibles' }}
          </h3>
          <p class="text-muted">
            <span *ngIf="hasActiveFilters()">
              No hay cuentas que coincidan con los filtros seleccionados.
              <br>
              <button type="button" class="btn btn-link p-0" (click)="clearFilters()">
                Limpiar filtros para ver todas las cuentas
              </button>
            </span>
            <span *ngIf="!hasActiveFilters()">
              Esta opción de pago no tiene cuentas asociadas.
            </span>
          </p>
        </div>
      </div>

      <!-- Statistics Footer -->
      <div *ngIf="!accountPayment_load && accountPaymentFiltered?.length > 0" class="row mt-4">
        <div class="col-12">
          <div class="card stats-card">
            <div class="card-body">
              <div class="row text-center">
                <div class="col-6 col-md-3">
                  <div class="stat-item">
                    <span class="stat-number text-primary">{{ getTotalAccountsCount() }}</span>
                    <span class="stat-label">{{ hasActiveFilters() ? 'Filtradas' : 'Total' }}</span>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="stat-item">
                    <span class="stat-number text-primary">{{ getActiveAccountsCount() }}</span>
                    <span class="stat-label">Activas</span>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="stat-item">
                    <span class="stat-number text-info">{{ getAutomaticAccountsCount() }}</span>
                    <span class="stat-label">Automáticas</span>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="stat-item">
                    <span class="stat-number text-warning">{{ getManualAccountsCount() }}</span>
                    <span class="stat-label">Manuales</span>
                  </div>
                </div>
                </div>
              </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
